import React from "react";
import PlusWhiteIcon from "../../Assets/Images/plus-white.svg";
import CheckIcon from "../../Assets/Images/check-white-icon.svg";
import CriticalIllnessTabImage from "../../Assets/Images/critical-illness-tab-mobile-image.png";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

const CoveredHalf = () => {
  const translations = useTranslation(); // Get translations dynamically
  return (
    <>
      <div className="flex flex-col lg:mt-[5rem] mt-[2rem] ">
        <div className="animate__animated animate__fadeInRight lg:hidden block -mr-4 mb-10">
          <img
            src={CriticalIllnessTabImage}
            width={"100%"}
            className="object-cover  w-full"
            alt="not found"
          />
        </div>
        <div className="mt-2 mb-4 animate__animated animate__fadeIn lg:max-w-[450px] md:px-0 px-4 cover25-content">
          <p className="md:text-[16px] text-[14px] mb-3 extra-para-vs">
            {translations.coveredHalf.description1}
          </p>
          <div className="flex mt-6">
            <div className="w-1/2">
              <ul className="md:text-[16px] text-[14px]">
                <li className="flex items-center mb-4 extra-para-vs">
                  <div class="flex items-center justify-center w-4 h-4 min-w-[16px] min-h-[16px] bg-[#ED1C2C] rounded-full covered-col-circle ">
                    <img
                      src={CheckIcon}
                      alt="Check Icon"
                      class="w-[10px] h-[10px]"
                    />
                  </div>
                  <span className="ml-1.5">
                    {" "}
                    {translations.coveredHalf.procedures.coronaryBypass}
                  </span>
                </li>
              </ul>
            </div>
            <div className="w-1/2">
              <ul>
                <li className="flex items-center mb-4 extra-para-vs">
                  <div class="flex items-center justify-center w-4 h-4 min-w-[16px] min-h-[16px] bg-[#ED1C2C] rounded-full covered-col-circle">
                    <img
                      src={CheckIcon}
                      alt="Check Icon"
                      class="w-[10px] h-[10px]"
                    />
                  </div>
                  <span className="ml-1.5">
                    {" "}
                    {translations.coveredHalf.procedures.heartValveSurgery}
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <p className="md:text-[16px] text-[14px] mb-3 mt-2 extra-para-vs">
            {translations.coveredHalf.description2}
          </p>
          <div className="flex mt-6">
            <div className="w-1/2">
              <ul className="md:text-[16px] text-[14px]">
                <li className="flex items-center mb-4 extra-para-vs">
                  <div class="flex items-center justify-center w-4 h-4 min-w-[16px] min-h-[16px] bg-[#0D4248] rounded-full covered-col-circle">
                    <img
                      src={CheckIcon}
                      alt="Check Icon"
                      class="w-[10px] h-[10px]"
                    />
                  </div>
                  <span className="ml-1.5">
                    {" "}
                    {translations.coveredHalf.procedures.coronaryAngioplasty}
                  </span>
                </li>
              </ul>
            </div>
            <div className="w-1/2"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CoveredHalf;
